import React from 'react'
import { cn } from '../../lib/utils'

const Input = React.forwardRef(({ className, type = 'text', ...props }, ref) => (
  <input
    ref={ref}
    type={type}
    className={cn(
      'flex h-11 w-full rounded-lg border border-white/30 bg-white/20 px-4 text-sm text-gray-900 shadow-[inset_0_-6px_2px_-4px_rgba(255,255,255,0.3),inset_0_0_15px_rgba(255,255,255,0.1),0_2px_8px_rgba(0,0,0,0.1)] transition-colors placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:bg-white/5 dark:text-gray-100 dark:placeholder:text-gray-400',
      className
    )}
    {...props}
  />
))

Input.displayName = 'Input'

export { Input }
